import { render, staticRenderFns } from "./AlertTypes.vue?vue&type=template&id=bc4487e4"
import script from "./AlertTypes.vue?vue&type=script&lang=js"
export * from "./AlertTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports